<!-- Main content container -->
<div *ngIf="rainNode" class="raain-details-container">

    <!-- Period selection section -->
    <ion-card class="period-card">
        <ion-card-content>
            <div class="period-controls">
                <div class="period-row">

                    <ion-button (click)="toggleHistory = !toggleHistory; onEnableCountHistoryTab(rainNode)"
                                fill="outline">
                        <ion-icon name="calendar-clear-outline" slot="start"></ion-icon>
                        <ion-icon [name]="toggleHistory ? 'chevron-down' : 'chevron-forward'" slot="end"></ion-icon>
                    </ion-button>

                    <div class="period-start ion-hide-md-down">
                        <input (change)="onPeriodBeginChange($event)"
                               [disabled]="toggleCumulative"
                               [value]="periodBeginAsString"
                               class="datetime-input"
                               type="datetime-local">
                    </div>

                    <div class="period-duration ion-hide-md-down">
                        <ion-select (ionDismiss)="onPeriodDurationChange($event)"
                                    [(ngModel)]="periodDurationAsString"
                                    class="duration-select"
                                    id="periodDuration"
                                    interface="popover">
                            <ion-select-option value="0.25">15 minutes</ion-select-option>
                            <ion-select-option value="0.5">30 minutes</ion-select-option>
                            <ion-select-option value="1">1 hour</ion-select-option>
                            <ion-select-option value="2">2 hours</ion-select-option>
                            <ion-select-option value="3">3 hours</ion-select-option>
                            <ion-select-option value="4">4 hours</ion-select-option>
                            <ion-select-option value="5">5 hours</ion-select-option>
                            <ion-select-option value="6">6 hours</ion-select-option>
                            <ion-select-option value="8">8 hours</ion-select-option>
                            <ion-select-option value="10">10 hours</ion-select-option>
                            <ion-select-option value="12">12 hours</ion-select-option>
                            <ion-select-option *ngIf="isAdmin" value="24">24 hours</ion-select-option>
                        </ion-select>
                    </div>

                    <div class="period-start ion-hide-md-down">
                        <input (change)="onPeriodEndChange($event)"
                               [disabled]="!toggleCumulative"
                               [value]="periodEndAsString"
                               class="datetime-input"
                               type="datetime-local">
                    </div>

                    <div class="toggle-cumulative">
                        <ion-label [class.text-primary]="toggleCumulative">
                            {{ toggleCumulative ? 'Cumulative' : 'Granular' }}
                        </ion-label>
                        <ion-toggle (ionChange)="toggleCumulativeChanged($event)"
                                    [(ngModel)]="toggleCumulative"
                                    [checked]="toggleCumulative">
                        </ion-toggle>
                    </div>
                </div>

                <!-- Hidden label for change detection (uncomment to debug)
                <div class="hidden-label">{{ onChangeDetectionTest(rainNode) }}</div>
                -->
            </div>

            <!-- Historical map section -->
            <div *ngIf="toggleHistory" class="period-controls">
                <raain-date-dynamic (changedDate)="onDateChangeInCount($event)"
                                    [currentHeight]="300"
                                    [fetchData]="fetchDataWrapper"
                                    [points]="countPoints">
                </raain-date-dynamic>
            </div>
        </ion-card-content>
    </ion-card>

    <!-- Map performance -->
    <ion-grid class="map-performance">
        <ion-row id="progressAndRefresh">
            <ion-col class="provider-selection" size="12" size-md="6">
                <ion-button (click)="openQualityModal()" class="quality-info-button" fill="clear">
                    {{ refreshManager.rainComputationMapVersion }}
                    <ion-icon name="help-circle-outline" slot="end"></ion-icon>
                </ion-button>
                <div *ngIf="availableProviders.length > 0 || availableTimeSteps.length > 0" class="selection-row">
                    <ion-select (ionChange)="onProviderChanged($event)"
                                [value]="selectedProvider"
                                interface="popover"
                                label="Provider"
                                placeholder="Select Provider">
                        <ion-select-option *ngFor="let provider of availableProviders" [value]="provider">
                            {{ provider }}
                        </ion-select-option>
                    </ion-select>

                    <ion-select (ionChange)="onTimeStepChanged($event)"
                                [value]="selectedTimeStep"
                                interface="popover"
                                label="Time Step"
                                placeholder="Select Time Step">
                        <ion-select-option *ngFor="let step of availableTimeSteps" [value]="step">
                            {{ step }} min
                        </ion-select-option>
                    </ion-select>
                </div>
            </ion-col>
            <ion-col class="ion-text-right" size="12" size-md="6">
                <ion-label class="ion-margin-end">
                            <span *ngIf="percentOfComputations">
                                {{ percentOfComputations }}% Images
                                <i *ngIf="countsPeriod.progress" class="progress-indicator">
                                    In Progress: {{ countsPeriod.progress }}...
                                </i>
                            </span>
                    <span *ngIf="!percentOfComputations">
                                No image available
                            </span>

                </ion-label>

                <ion-button (click)="refreshMap()" [disabled]="refreshInProgress" class="refresh-button">
                    Refresh Map
                </ion-button>
            </ion-col>
        </ion-row>

        <!-- status update row -->
        <ion-row>
            <!-- Progress col -->
            <ion-progress-bar
                    [buffer]="(countsPeriod.progress / ((timeframeDates?.length || 10) +3))+0.01"
                    [style.visibility]="refreshInProgress ? 'visible' : 'hidden'"
                    [value]="countsPeriod.progress / ((timeframeDates?.length || 10) +3)"
                    color="primary">
            </ion-progress-bar>

            <!-- Error col -->
            <ion-col (click)="showFullError = !showFullError" *ngIf="refreshManager.lastError" class="error-row"
                     size="12">
                <div class="error-content">
                    <ion-icon class="error-icon" name="warning-outline"></ion-icon>
                    <span [class.expanded]="showFullError" class="error-text">
                        {{ showFullError ? refreshManager.lastError : truncatedError }}
                    </span>
                    <ion-icon [name]="showFullError ? 'chevron-up' : 'chevron-down'" class="error-caret"></ion-icon>
                </div>
            </ion-col>
        </ion-row>
    </ion-grid>

    <!-- Map section -->
    <ion-card class="map-card">
        <ion-card-content class="map-content">
            <ion-grid>
                <ion-row *ngIf="toggleMap && percentOfImages">
                    <!-- Map component -->
                    <ion-col class="map-column" size-lg="7" size-md="12">
                        <div class="map-container">
                            <raain-map #raainMapRef
                                       (changedDate)="onDateChangeInMap($event)"
                                       (changedSum)="onSumChangeInMap($event)"
                                       (selectedMarker)="onGaugeSelectInMap($event)"
                                       [coordinates]="coordinates"
                                       [cumulativeDurationInMinutes]="cumulativeDurationInMinutes"
                                       [currentHeight]="500"
                                       [defaultDate]="dateShown"
                                       [markers]="{
                                        borders,
                                        gauges: compareManager.gaugesInMap,
                                        gaugesInCompare: compareManager.gaugesInCompare,
                                        selectedGauges: compareManager.selectedGauges,
                                        pixels: compareManager.selectedPixels,
                                        pixelsSolution: compareManager.pixelsSolutions?.length ? compareManager.pixelsSolutions[0] : [],
                                        speeds: compareManager.speeds
                                    }"
                                       [showCumulative]="toggleCumulative"
                                       [showVisiblePixelMarkers]="showPixelMarkers"
                                       [sumFn]="refreshManager.sumFn"
                                       [sumValues]="refreshManager.sumValues"
                                       [timeframeContainers]="timeframeContainers"
                                       [timeframeDates]="timeframeDates">
                            </raain-map>
                        </div>

                        <div class="data-column">
                            <!-- Technical details (collapsible for cleaner UI) -->
                            <details class="technical-details">
                                <summary>Image Details</summary>
                                <div class="details-content">
                                    <div class="detail-row">
                                        <span class="detail-label">Computed:</span>
                                        <span class="detail-value">{{ refreshManager.rainComputationMapDoneDate | date:'yyyy-MM-dd HH:mm' }}</span>
                                    </div>
                                    <div class="detail-row">
                                        <span class="detail-label">Version:</span>
                                        <span class="detail-value">{{ refreshManager.rainComputationMapVersion }}</span>
                                    </div>
                                    <div class="detail-row">
                                        <span class="detail-label">Launched by:</span>
                                        <span class="detail-value">{{ refreshManager.rainComputationMapLaunchedBy }}</span>
                                    </div>
                                    <div class="detail-row">
                                        <span class="detail-label">Time spent:</span>
                                        <span class="detail-value">{{ refreshManager.rainComputationMapTimeSpentInMs }}
                                            ms</span>
                                    </div>
                                    <div class="detail-row">
                                        <span class="detail-label">Date:</span>
                                        <span class="detail-value">{{ refreshManager.rainComputationMapDate?.toISOString() }}
                                            | {{ refreshManager.rainComputationMapDate | date:'yyyy-MM-dd HH:mm' }}</span>
                                    </div>
                                    <div class="detail-row">
                                        <span class="detail-label">Water in the map:</span>
                                        <span class="detail-value">{{ sumDetails }}</span>
                                        <ion-toggle
                                                (ionChange)="onTogglePixelMarkers()"
                                                [(ngModel)]="showPixelMarkers"
                                                style="margin-left: 8px; transform: scale(0.7);">
                                        </ion-toggle>
                                    </div>
                                    <div class="detail-row">
                                        <span class="detail-label">Source DBZ min:</span>
                                        <span class="detail-value">{{ refreshManager.rainComputationMapOriginalMin }}</span>
                                    </div>
                                    <div class="detail-row">
                                        <span class="detail-label">Source DBZ max:</span>
                                        <span class="detail-value">{{ refreshManager.rainComputationMapOriginalMax }}</span>
                                    </div>
                                </div>
                            </details>
                        </div>
                    </ion-col>

                    <!-- Data panel -->
                    <ion-col *ngIf="!!compareManager.compareVersion" class="data-column" size-lg="5" size-md="12">
                        <div class="data-panel">
                            <!-- Compare stack component -->
                            <div class="compare-stack">
                                <raain-compare-stack
                                        (selectedPoint)="onGaugeSelectInCompare($event)"
                                        [compareManager]="compareManager"
                                        [cumulative]="toggleCumulative">
                                </raain-compare-stack>
                            </div>

                            <!-- Technical details (collapsible for cleaner UI) -->
                            <details class="technical-details">
                                <summary>Compare Details</summary>
                                <div class="details-content">
                                    <div [ngClass]="{'warning': refreshManager.rainComputationMapDoneDate?.getTime() > compareManager.currentQualityDoneDate?.getTime() + 60000}"
                                         class="detail-row">
                                        <span class="detail-label">Computed:</span>
                                        <span class="detail-value">{{ compareManager.currentQualityDoneDate | date:'yyyy-MM-dd HH:mm' }}</span>
                                    </div>
                                    <div class="detail-row">
                                        <span class="detail-label">Version:</span>
                                        <span class="detail-value">{{ compareManager.compareVersion }}</span>
                                    </div>
                                    <div class="detail-row">
                                        <span class="detail-label">Launched by:</span>
                                        <span class="detail-value">{{ compareManager.currentQualityLaunchedBy }}</span>
                                    </div>
                                    <div class="detail-row">
                                        <span class="detail-label">Time spent:</span>
                                        <span class="detail-value">{{ compareManager.currentQualityTimeSpentInMs }}
                                            ms</span>
                                    </div>
                                    <div class="detail-row">
                                        <span class="detail-label">Gauges:</span>
                                        <span class="detail-value">{{ compareManager.gaugesInCompare.length }}</span>
                                    </div>
                                    <div class="detail-row">
                                        <span class="detail-label">Points:</span>
                                        <span class="detail-value">{{ compareManager.globalComparePoints.length }}</span>
                                    </div>
                                </div>
                            </details>
                        </div>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <!-- Bottom progress bar -->
                    <ion-progress-bar *ngIf="refreshInProgress"
                                      [buffer]="(countsPeriod.progress / ((timeframeDates?.length || 10) +3))+0.01"
                                      [value]="countsPeriod.progress / ((timeframeDates?.length || 10) +3)"
                                      color="primary">
                    </ion-progress-bar>
                </ion-row>
            </ion-grid>
        </ion-card-content>
    </ion-card>

    <!-- Gauge values section -->
    <ion-card *ngIf="gaugeSelectedPoints.length && gaugeSelectedPoints[0].values.length" class="gauge-card">
        <ion-card-header>
            <ion-card-title>
                <ion-icon name="analytics-outline"></ion-icon>
                Selected Gauge Data
            </ion-card-title>
        </ion-card-header>
        <ion-card-content>
            <raain-date-focus
                    [currentHeight]="300"
                    [focusDate]="periodBegin"
                    [focusRange]="DateRange.DAY"
                    [points]="gaugeSelectedPoints"
                    [withoutAll]="true">
            </raain-date-focus>
        </ion-card-content>
    </ion-card>

    <!-- Quality Performance Modal -->
    <div (click)="closeQualityModal()" *ngIf="showQualityModal" class="quality-modal-overlay">
        <div (click)="$event.stopPropagation()" class="quality-modal-content">
            <div class="quality-modal-header">
                <h2>Model Quality Performance</h2>
                <ion-button (click)="closeQualityModal()" fill="clear">
                    <ion-icon name="close-outline"></ion-icon>
                </ion-button>
            </div>
            <div class="quality-modal-body">
                <div *ngIf="qualityIndicatorsLoading" class="quality-loading">
                    <ion-spinner name="crescent"></ion-spinner>
                    <span>Loading indicators...</span>
                </div>
                <div *ngIf="!qualityIndicatorsLoading && qualityIndicators.length === 0" class="quality-empty">
                    No quality indicators available for this year.
                </div>
                <table *ngIf="!qualityIndicatorsLoading && qualityIndicators.length > 0" class="quality-table">
                    <thead>
                    <tr>
                        <th>Model</th>
                        <th>Compare</th>
                        <th>Gauges</th>
                        <th>Period</th>
                        <th>Avg Quality</th>
                        <th>Updated</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let indicator of qualityIndicators">
                        <td>{{ indicator.computingVersion }}</td>
                        <td>{{ indicator.qualityVersion }}</td>
                        <td>{{ indicator.provider }}<br>{{ indicator.timeStepInMinutes }} min</td>
                        <td>{{ formatDate(indicator.startDate) }}<br>{{ formatDate(indicator.endDate) }}</td>
                        <td>{{ indicator.averageQuality | number:'1.2-2' }}</td>
                        <td>{{ formatDate(indicator.lastUpdatedAt) }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

</div>
